import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { UserPlus } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function InviteDialog({ open, onOpenChange, venueName, authConfig }) {
  const [form, setForm] = useState({ username: "", email: "", password: "" });

  const submit = async () => {
    if (!form.username.trim() || !form.email.trim() || !form.password.trim()) return;
    try {
      const res = await axios.post(`${API}/venue/invite`, form, authConfig());
      toast.success(res.data.message);
      setForm({ username: "", email: "", password: "" });
      onOpenChange(false);
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to create admin"); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) setForm({ username: "", email: "", password: "" }); onOpenChange(v); }}>
      <DialogContent className="bg-[#141414] border-white/10 rounded-none max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-heading text-white text-xl flex items-center gap-2">
            <UserPlus className="h-5 w-5 text-[#E3292E]" /> Invite Admin to Venue
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-white/50 text-sm font-body">Create a new admin account for <span className="text-white font-bold">{venueName || "your venue"}</span>. They can log in immediately.</p>
          <div className="space-y-3">
            <Input value={form.username} onChange={(e) => setForm((p) => ({ ...p, username: e.target.value }))} placeholder="Username" className="bg-transparent border-white/20 text-white rounded-none focus-visible:ring-1 focus-visible:ring-[#E3292E]" data-testid="invite-username-input" />
            <Input type="email" value={form.email} onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))} placeholder="Email" className="bg-transparent border-white/20 text-white rounded-none focus-visible:ring-1 focus-visible:ring-[#E3292E]" data-testid="invite-email-input" />
            <Input type="password" value={form.password} onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))} placeholder="Password" className="bg-transparent border-white/20 text-white rounded-none focus-visible:ring-1 focus-visible:ring-[#E3292E]" data-testid="invite-password-input" />
          </div>
          <Button onClick={submit} disabled={!form.username.trim() || !form.email.trim() || !form.password.trim()} className="w-full bg-[#E3292E] hover:bg-[#DC2626] text-white rounded-none font-heading font-bold" data-testid="invite-submit-btn">
            <UserPlus className="mr-2 h-4 w-4" /> CREATE ADMIN
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
